import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
declare var $;

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
/** status component*/
export class StatusComponent {
  /** status ctor */

  showModal: boolean;
  title: string;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any;

  constructor() {
    localStorage.aEID = 0;

  }
  ngOnInit(): void {
    this.getstatusList();
  }
  getstatusList(): void {
    $("#LoadingImage").show();
    let nPublisherId = localStorage.aPubID;
    ApiMethod.getMethod('gen/statusList/' + localStorage.aLoginID + '/' + nPublisherId).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.aStatusList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.aColListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 75);
        dataItem.modulename = 'StatusModule';
        dataItem.rowSelect = true;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  clearData(): void {
    let form: NgForm = $('form#frmStatus');
    form[0].reset();
  }

  //Show Status control popup
  show(): void {
    this.clearData();
    if (localStorage.aEID != 0) {
      $("#LoadingImage").show();
      ApiMethod.getMethod('gen/StatusByID/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();
          let itemL = result.aStatusitem;
          $('#txtStatusName').val(itemL.StatusName);
          $('#txtModuleName').val(itemL.ModuleName);
        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
    this.showModal = true; // Show-Hide Modal Check
    this.title = "Status Details";    // Dynamic Data

  }

  //Bootstrap Modal Close event
  hide() {
    this.clearData();
    this.showModal = false;
  }

  //Update Status details method
  updateStatusDetails(): void {
    if ($('#txtStatusName').val().trim() == '') {
      ngswal("Warning !", "Enter Status Name !", "warning");
    }
    else if ($('#txtModuleName').val().trim() == '') {
      ngswal("Warning !", "Enter Module Name!", "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var aStatuitemL = {
        ID: localStorage.aEID,
        StatusName: $('#txtStatusName').val(),
        ModuleName: $('#txtModuleName').val(),
        UpdatedBy: localStorage.aLoginID,
      };
      ApiMethod.postMethod('gen/updatestatus', aStatuitemL).subscribe(
        response => {
          this.getstatusList();
          $("#LoadingImagePopup").hide();
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response,
            showConfirmButton: false,
            timer: 1500
          });
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );

    }
  }

}
